/* eslint-disable indent */
/* eslint-disable no-shadow */
import {
  Button,
  Dialog,
  Form,
  Message,
  NumberPicker,
  Radio,
  Select,
  Table,
} from '@alifd/next';
import {
  CheckOutlined,
  CloseOutlined,
  DeleteOutlined,
  EditOutlined,
  UploadOutlined,
} from '@ant-design/icons';
import {
  Checkbox,
  Col,
  Input,
  InputNumber,
  Row,
  Space,
  Spin,
  Switch,
  Tag,
  Typography,
  Upload,
} from 'antd';
import axios from 'axios';
import moment from 'moment';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { SketchPicker } from 'react-color';
import ReactDragListView from 'react-drag-listview';
import Swal from 'sweetalert2';

import client from '../../../../lib/feathers';
import TemplateContent from './templateContent';
import styles from './templateSetting.module.scss';
const { Item } = Form;
const { Option, OptionGroup } = Select;
const { CheckableTag } = Tag;
const BroadcastTemplateSetting = (props) => {
  const categoryMenu = useMemo(() => client.service('categoryMenu'), []);
  const uploads = client.service('uploads');
  const { addTemplateContent, setAddTemplateContent } = props;
  const uploadRef = useRef(null);
  const [TemplateDialog, setTemplateDialog] = useState(false);
  const [TemplateDialogTitle, setTemplateDialogTitle] = useState(0);
  const [TemplateDialogCount, setTemplateDialogCount] = useState(0);
  const [TemplateUpdateIndex, setTemplateUpdateIndex] = useState(0);

  const [city, setCity] = useState('新北市');
  const [showAddColor, setShowAddColor] = useState(false);
  const [typeContent, setTypeContent] = useState('weather');
  const [typeFormat, setTypeFormat] = useState('');
  const [typeArea, setTypeArea] = useState('');
  const [textSize, setTextSize] = useState(20);
  const [textTags, setTextTags] = useState([]);
  const [textColor, setTextColor] = useState('#000000');
  const [textLevel, setTextLevel] = useState('center');
  const [textVertical, setTextVertical] = useState('center');
  const [unitValue, setUnitValue] = useState('s');
  const [secValue, setSecValue] = useState(10);
  const [checkValue, setCheckValue] = useState([]);
  const [endTime, setEndTime] = useState(10);
  const [sound, setSound] = useState(true);
  const [videoId, setVideoId] = useState('');
  const [maxEndTime, setMaxEndTime] = useState(10);
  const [youtubeTitle, setYoutubeTitle] = useState('');
  // 媒體庫
  const [TemplateImageDialog, setTemplateImageDialog] = useState(false);
  const [TemplateImageChangeDialog, setTemplateImageChangeDialog] =
    useState(false);
  const [upLoading, setUpLoading] = useState(false);
  const [mediaImage, setMediaImage] = useState(false);
  const [mediaCheckValue, setMediaCheckValue] = useState(false);
  const [mediaType, setMediaType] = useState('all');
  const [mediaIndex, setMediaIndex] = useState('');
  const [mediaUpdate, setMediaUpdate] = useState(false);

  // 即時資訊
  const [typeValueDialog, setTypeValueDialog] = useState(false);
  const [typeValue, setTypeValue] = useState({});
  const [typeValueData, setTypeValueData] = useState([]);
  const [editable, setEditable] = useState('');
  const [typeColumns, setTypeColumns] = useState([]);
  const [errorText, setErrorText] = useState('');
  const [errorTable, setErrorTable] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  // mp4影片
  const [uploadPath, setUploadPath] = useState('');
  const [uploadData, setUploadData] = useState(null);
  const [backgroundMusic, setBackgroundMusic] = useState(null);
  const [NewMp4, setNewMp4] = useState({ videoDuration: 0 });
  const [soundLoading, setSoundLoading] = useState(false);

  const tagsData = ['粗體', '斜體'];
  const cityList = [
    '台北市',
    '基隆市',
    '新北市',
    '連江縣',
    '宜蘭縣',
    '新竹市',
    '新竹縣',
    '桃園市',
    '苗栗縣',
    '台中市',
    '彰化縣',
    '南投縣',
    '嘉義市',
    '嘉義縣',
    '雲林縣',
    '台南市',
    '高雄市',
    '澎湖縣',
    '金門縣',
    '屏東縣',
    '台東縣',
    '花蓮縣',
  ];

  const unit = [
    { name: 'CO₂', unitValue: 1, unitName: 'ppm' },
    { name: 'PM₂.₅', unitValue: 1, unitName: 'μg/m³' },
    { name: 'PM₁₀', unitValue: 1, unitName: 'μg/m³' },
    { name: 'PM₁.₀', unitValue: 1, unitName: 'μg/m³' },
    { name: 'TVOC', unitValue: 1, unitName: 'mg/m³' },
    { name: 'CH₂O', unitValue: 1, unitName: 'mg/m³' },
    { name: '照度', unitValue: 1, unitName: 'lux' },
    { name: '溫度', unitValue: 1, unitName: '°C' },
    { name: '濕度', unitValue: 1, unitName: '%' },
  ];
  // 時間下拉式選單
  const selectAfter = (
    <Select
      value={unitValue}
      className="select-after"
      onChange={(value) => setUnitValue(value)}
    >
      <Option value="s">秒</Option>
      <Option value="m">分</Option>
    </Select>
  );
  useEffect(() => {
    (async () => {
      const res2 = await uploads.find({
        query: {
          orignalName: {
            $regex: 'jpg|jpeg|gif|png',
          },
          $or: [{ type: 'announceBroadcast' }, { type: 'broadcast' }],
        },
      });
      // $or: [{ type: 'announcement' }, { type: 'broadcast' }],
      console.log(res2.data, '===res2.data');
      setMediaImage(res2.data);
    })();
  }, [categoryMenu, typeContent, uploads, isUpdate]);

  const ChangeTypeValue = (num, type, value) => {
    addTemplateContent[num][type] = value;
    setAddTemplateContent(addTemplateContent.map((x) => ({ ...x })));
  };
  // tag處理
  const handleChange = (tag, checked) => {
    const nextSelectedTags = checked
      ? [...textTags, tag]
      : textTags.filter((t) => t !== tag);

    setTextTags(nextSelectedTags);
  };
  // 拖拉功能
  const onDragCategoryEnd = (fromIndex, toIndex, count) => {
    const items = addTemplateContent[count].children; // 所有類別資料
    const item = items.splice(fromIndex, 1)[0];
    items.splice(toIndex, 0, item); // 把刪除的新增到移動的位置
    addTemplateContent[count].children = items;
    setAddTemplateContent(addTemplateContent.map((x) => ({ ...x })));
    Message.success('拖曳成功');
  };
  const onChangeInitialValue = () => {
    setTypeContent('weather');
    setCity('新北市');
    setTypeFormat('');
    setTypeArea('');
    setTextSize(20);
    setTextTags([]);
    setTextColor('#000000');
    setTextLevel('center');
    setTextVertical('center');
    setSecValue(10);
    setEndTime(10);
    setMaxEndTime(10);
    setSound(true);
  };
  // 新增/修改
  const onChangeTemplateContent = async (type) => {
    if (typeContent === 'youtube' && typeFormat.indexOf('?v=') < 0) {
      Message.error('輸入網址錯誤');
      return;
    }
    let NewBackgroundMusic = { ...backgroundMusic };
    if (uploadData) {
      // const body = new FormData();
      // body.append('files', uploadData);
      // const res = await fetch('/newUploads?type=broadcast', {
      //   method: 'POST',
      //   body,
      //   headers: { authorization: window.localStorage['feathers-jwt'] },
      // });
      // console.log(await res.json());
      // const { showPath, _id } = await res.json();
      // NewBackgroundMusic = {
      //   path: showPath,
      //   name: uploadData.name,
      //   id: _id,
      // };
      NewBackgroundMusic = NewMp4;
    }

    if (typeContent === 'mp4' && NewBackgroundMusic?.path === undefined) {
      Message.error('請上傳檔案');
      return;
    }
    let obj;
    if (type === 'image') {
      obj = mediaCheckValue;
    } else {
      obj = [
        {
          typeContent,
          typeFormat,
          textSize,
          textTags,
          textColor,
          textLevel,
          textVertical,
          unit: unitValue,
          seconds: secValue,
          checkMarquee: checkValue.includes('checkMarquee'),
          checkTextSound: checkValue.includes('checkTextSound'),
        },
      ];
      if (typeContent === 'weather') obj[0].typeFormat = city;
      if (typeContent === 'text') obj[0].typeFormat = typeArea;
      if (typeContent === 'iframe') obj[0].typeFormat = typeArea;

      if (typeContent === 'youtube') {
        obj[0].endTime = endTime;
        obj[0].startTime = secValue;
        obj[0].sound = sound ? 0 : 1;
        obj[0].seconds = endTime * 1 - secValue * 1 + 1;
        obj[0].url = videoId;
        obj[0].maxEndTime = maxEndTime;
        obj[0].youtubeTitle = youtubeTitle;
      }
      if (typeContent === 'mp4') {
        obj[0].url = NewBackgroundMusic;
        obj[0].sound = sound ? 0 : 1;
        obj[0].youtubeTitle = youtubeTitle;
        obj[0].maxEndTime = NewBackgroundMusic.videoDuration;
      }
      if (obj[0].seconds === '') obj[0].seconds = 1;
    }
    console.log(obj, '===obj');

    if (TemplateDialogTitle === 'insert') {
      addTemplateContent[TemplateDialogCount].children.push(...obj);
    } else {
      addTemplateContent[TemplateDialogCount].children[TemplateUpdateIndex] =
        obj[0];
    }
    setAddTemplateContent(addTemplateContent);
    setTemplateDialog(false);
    setUploadData(null);
    setUploadPath(null);
    setBackgroundMusic(null);
  };

  const onsetUpdateValue = (value) => {
    setTypeContent(value.typeContent);
    setCity(value.city);
    setTypeFormat(value.typeFormat);
    if (value.typeContent === 'weather') setCity(value.typeFormat);
    if (value.typeContent === 'text') setTypeArea(value.typeFormat);
    if (value.typeContent === 'iframe') setTypeArea(value.typeFormat);
    setTextSize(value.textSize);
    setTextTags(value.textTags);
    setTextColor(value.textColor);
    setTextLevel(value.textLevel);
    setTextVertical(value.textVertical);
    setUnitValue(value.unit);

    setBackgroundMusic(value.url);
    setYoutubeTitle(value.youtubeTitle);
    if (value.typeContent === 'youtube') {
      setSecValue(value.startTime);
      setMaxEndTime(value.maxEndTime);
    } else {
      setSecValue(value.seconds);
    }
    setEndTime(value.endTime);
    const checkValue = [];
    if (value.checkMarquee) checkValue.push('checkMarquee');
    if (value.checkTextSound) checkValue.push('checkTextSound');
    setCheckValue(checkValue);
  };

  const onDeleteTemplateValue = (count, index) => {
    const newAddTemplateContent = [...addTemplateContent];
    newAddTemplateContent[count].children.splice(index, 1);
    setAddTemplateContent(newAddTemplateContent);
  };
  // 圖片上傳
  const beforeUpload = async (file) => {
    try {
      setUpLoading(true);
      const formData = new FormData();
      formData.append('files', file);
      await fetch('/newUploads?type=broadcast&createCompressImage=true', {
        method: 'POST',
        body: formData,
        headers: { authorization: window.localStorage['feathers-jwt'] },
      });
      const res2 = await uploads.find({
        query: {
          orignalName: {
            $regex: 'jpg|jpeg|gif|png',
          },
          $or: [{ type: 'announceBroadcast' }, { type: 'broadcast' }],
        },
      });
      setMediaImage(res2.data);
      setUpLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  // 選擇媒體庫圖片
  const onChange = (checkedValues) => {
    const newMediaImage = [];
    for (let i = 0; i < checkedValues.length; i++) {
      const checkValue = {
        typeContent: 'image',
        typeFormat: checkedValues[i],
        textSize: 'fullVersion',
        textTags: '',
        textColor: '',
        textLevel,
        textVertical,
        unit: unitValue,
        seconds: secValue,
      };
      newMediaImage.push(checkValue);
    }
    setMediaCheckValue(newMediaImage);
  };
  // 媒體庫類別篩選
  const onChangeMediaType = async (value) => {
    let res2 = '';
    if (value === 'all') {
      res2 = await uploads.find({
        query: {
          orignalName: {
            $regex: 'jpg|jpeg|gif|png',
          },
          $or: [{ type: 'announceBroadcast' }, { type: 'broadcast' }],
        },
      });
    } else {
      res2 = await uploads.find({
        query: {
          orignalName: {
            $regex: 'jpg|jpeg|gif|png',
          },
          $or: [{ type: value }],
        },
      });
    }

    setMediaImage(res2.data);
  };

  // 拖拉即時資訊欄位變更順序
  const onTypeDragCategoryEnd = (fromIndex, toIndex) => {
    const items = typeValueData; // 所有類別資料
    const item = items.splice(fromIndex, 1)[0];
    items.splice(toIndex, 0, item); // 把刪除的新增到移動的位置
    const newTypeValueData = [...items];
    setTypeValueData(newTypeValueData);
    Message.success('拖曳成功');
  };

  // 刪除媒體庫資料
  const onDeleteBox = () => {
    for (let i = 0; i < mediaCheckValue.length; i++) {
      uploads
        .find({ query: { showPath: mediaCheckValue[i].typeFormat } })
        .then((res) => {
          uploads
            .remove(res.data[0]._id)
            .then(() => {
              Message.success('刪除成功');
              setMediaCheckValue();
              uploads
                .find({
                  query: {
                    orignalName: {
                      $regex: 'jpg|jpeg|gif|png',
                    },
                    $or: [{ type: 'announceBroadcast' }, { type: 'broadcast' }],
                  },
                })
                .then((res2) => {
                  console.log(res2);
                  setMediaImage(res2.data);
                })
                .catch((err) => {
                  console.log(err);
                });
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  return (
    <div className={styles.container}>
      <TemplateContent
        {...{
          count: 0,
          addTemplateContent,
          ChangeTypeValue,
          setTemplateDialog,
          setTemplateDialogTitle,
          setTemplateDialogCount,
          onDragCategoryEnd,
          onChangeInitialValue,
          onsetUpdateValue,
          onDeleteTemplateValue,
          setTemplateUpdateIndex,
          setTemplateImageDialog,
          setTypeValueData,
          setTypeColumns,
        }}
      />

      {props.template !== 'one' && (
        <TemplateContent
          {...{
            count: 1,
            addTemplateContent,
            ChangeTypeValue,
            setTemplateDialog,
            setTemplateDialogTitle,
            setTemplateDialogCount,
            onDragCategoryEnd,
            onChangeInitialValue,
            onsetUpdateValue,
            onDeleteTemplateValue,
            setTemplateUpdateIndex,
            setTemplateImageDialog,
            setTypeValueData,
            setTypeColumns,
          }}
        />
      )}
      {props.template === 'four' && (
        <TemplateContent
          {...{
            count: 2,
            addTemplateContent,
            ChangeTypeValue,
            setTemplateDialog,
            setTemplateDialogTitle,
            setTemplateDialogCount,
            onDragCategoryEnd,
            onChangeInitialValue,
            onsetUpdateValue,
            onDeleteTemplateValue,
            setTemplateUpdateIndex,
            setTemplateImageDialog,
            setTypeValueData,
            setTypeColumns,
          }}
        />
      )}
      {/* 新增/編輯輪播內容 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={TemplateDialog}
        onOk={() => {
          onChangeTemplateContent();
        }}
        onCancel={() => {
          setTemplateDialog(false);
          onChangeInitialValue();
        }}
        onClose={() => {
          setTemplateDialog(false);
          onChangeInitialValue();
        }}
      >
        <Spin spinning={soundLoading}>
          <Form>
            <h3>
              {TemplateDialogTitle === 'insert' ? '新增' : '編輯'}輪播內容
            </h3>

            <Item label="類別" required>
              <Select
                placeholder="OptionGroup"
                style={{ width: '100%' }}
                value={typeContent}
                onChange={(value) => {
                  setTypeContent(value);
                  setCheckValue([]);
                  if (value === 'date') {
                    setTypeFormat('YYYY/MM/DD');
                  } else if (value === 'time') {
                    setTypeFormat('HH:mm');
                  } else if (value === 'dateTime') {
                    setTypeFormat('YYYY/MM/DD HH:mm:ss');
                  } else if (value === 'announcement') {
                    setTypeFormat('全部');
                    setTextVertical('start');
                  } else if (value === 'image') {
                    setTextSize('fullVersion');
                    setTemplateImageDialog(true);
                  } else if (value === 'weather') {
                    setCity('新北市');
                  } else if (value === 'youtube' || value === 'mp4') {
                    setTypeFormat('');
                    setYoutubeTitle('');
                  } else if (value === 'text' || value === 'iframe') {
                    setTypeFormat('');
                  } else {
                    let searchValue = '';
                    if (value === '自定義') {
                      searchValue = '';
                    } else {
                      searchValue = value;
                    }
                    axios
                      .get(`/ezcon/api/mqttTopic?topic=${searchValue}`, {
                        headers: {
                          authorization: localStorage.getItem('feathers-jwt'),
                        },
                      })
                      .then((res) => {
                        setTypeColumns(res.data);
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                    setTypeValueDialog(true);
                  }
                }}
              >
                <OptionGroup label="一般功能">
                  <Option value="weather">天氣</Option>
                  <Option value="date">日期</Option>
                  <Option value="time">時間</Option>
                  <Option value="dateTime">日期時間</Option>
                  <Option value="text">文字內容</Option>

                  {/* {TemplateDialogTitle === 'update' && ( */}
                  <Option value="image">圖片</Option>
                  {/* )} */}
                  <Option value="youtube">youtube影片</Option>
                  <Option value="mp4">MP4影片</Option>
                  <Option value="iframe">網頁</Option>
                </OptionGroup>
                <OptionGroup label="即時資訊">
                  <Option value="空氣品質">空氣品質</Option>
                  <Option value="照度">照度</Option>
                  <Option value="濕度">濕度</Option>
                  <Option value="溫度">溫度</Option>
                  <Option value="自定義">自定義</Option>
                </OptionGroup>
              </Select>
            </Item>
            {typeContent === 'image' ? (
              <>
                <Item label="圖片樣式">
                  <Select
                    style={{ width: '100%', textAlign: 'center' }}
                    onChange={(value) => setTextSize(value)}
                    value={textSize}
                  >
                    <Option value="fullVersion">滿版</Option>
                    <Option value="originalSize">原尺寸</Option>
                    <Option value="repeat">重複填滿</Option>
                  </Select>
                </Item>
                {TemplateDialogTitle === 'update' && (
                  <Item label="選擇圖片">
                    <Button
                      onClick={() => setTemplateImageChangeDialog(true)}
                      style={{ marginBottom: 10 }}
                    >
                      更換圖片
                    </Button>
                    <div>
                      <img
                        src={typeFormat}
                        width="100%"
                        alt="圖片"
                        style={{ width: '100px' }}
                      />
                    </div>
                  </Item>
                )}
              </>
            ) : (
              <>
                {typeContent === 'text' && (
                  <Item label="文字內容" required>
                    <Input.TextArea
                      rows={4}
                      value={typeArea}
                      placeholder="請輸入文字內容"
                      onChange={(e) => setTypeArea(e.target.value)}
                    />
                    <div>
                      <Checkbox.Group
                        defaultValue={checkValue}
                        onChange={(checkedValues) =>
                          setCheckValue(checkedValues)
                        }
                      >
                        <Checkbox value="checkMarquee">
                          跑馬燈效果(打勾將會有文字由右至左跑動）
                        </Checkbox>
                        <Checkbox value="checkTextSound">
                          文字轉語音(打勾將會播放文字語音）
                        </Checkbox>
                      </Checkbox.Group>
                    </div>
                  </Item>
                )}
                {typeContent === 'iframe' && (
                  <Item label="嵌入網址" required>
                    <Input.TextArea
                      rows={4}
                      value={typeArea}
                      placeholder="請輸入網址"
                      onChange={(e) => setTypeArea(e.target.value)}
                    />
                  </Item>
                )}
                {typeContent === 'youtube' && (
                  <Item label="網址" required>
                    <Input
                      value={typeFormat}
                      placeholder="例如：https://www.youtube.com...."
                      onChange={(e) => {
                        setTypeFormat(e.target.value);
                        let video_id;
                        if (e.target.value.indexOf('?v=') > 0) {
                          video_id = e.target.value.split('?v=')[1];
                          if (video_id.indexOf('&') > 0) {
                            video_id = video_id.split('&')[0];
                          }
                          setVideoId(video_id);
                          //key是申請 Youtube Data API V3
                          axios(
                            'https://www.googleapis.com/youtube/v3/videos?&part=contentDetails&id=' +
                              video_id +
                              '&key=AIzaSyBpXOrUa11AL4oZryfsfJVL0YtrAipsxd8',
                            {
                              method: 'GET',
                            }
                          ).then((res) => {
                            const PT =
                              res.data.items[0].contentDetails.duration.slice(
                                2,
                                res.data.items[0].contentDetails.duration.length
                              );
                            let H = 0,
                              M = 0,
                              S = 0;
                            console.log(PT);
                            if (PT.indexOf('H') > 0) {
                              H = PT.split('H')[0] * 1;
                              if (PT.split('H')[1].indexOf('M') > 0)
                                M = PT.split('H')[1].split('M')[0] * 1;
                              if (PT.split('H')[1].indexOf('S') > 0)
                                S =
                                  PT.split('H')[1].split('M')[1].split('S')[0] *
                                  1;
                            } else if (PT.indexOf('M') > 0) {
                              M = PT.split('M')[0] * 1;
                              if (PT.split('M')[1].indexOf('S') > 0)
                                S = PT.split('M')[1].split('S')[0] * 1;
                            } else if (PT.indexOf('S') > 0) {
                              S = PT.split('S')[0] * 1;
                            }
                            console.log(H, '===H');
                            console.log(M, '====M');
                            console.log(S, '====S');
                            setEndTime(H * 3600 + M * 60 + S);
                            setMaxEndTime(H * 3600 + M * 60 + S);
                          });
                          axios(
                            'https://www.googleapis.com/youtube/v3/videos?&part=snippet&id=' +
                              video_id +
                              '&key=AIzaSyBpXOrUa11AL4oZryfsfJVL0YtrAipsxd8',
                            {
                              method: 'GET',
                            }
                          ).then((res) => {
                            setYoutubeTitle(res.data.items[0].snippet.title);
                          });
                        } else {
                          setYoutubeTitle('');
                          setEndTime(10);
                          setMaxEndTime(10);
                          setSecValue(1);
                        }
                      }}
                    />
                  </Item>
                )}

                {(typeContent === 'date' ||
                  typeContent === 'dateTime' ||
                  typeContent === 'time' ||
                  typeContent === 'weather') && (
                  <Item
                    label={typeContent === 'weather' ? '顯示區域' : '樣式/類別'}
                  >
                    {typeContent === 'date' && (
                      <Radio.Group
                        itemDirection="ver"
                        onChange={(value) => setTypeFormat(value)}
                        value={typeFormat}
                      >
                        <Radio value="YYYY/MM/DD">
                          格式一(ex:{moment().format('YYYY/MM/DD')})
                        </Radio>
                        <Radio value="YYYY-MM-DD">
                          格式二(ex:{moment().format('YYYY-MM-DD')})
                        </Radio>
                        <Radio value="YYYY年MM月DD日dddd">
                          格式三(ex:{moment().format('YYYY年MM月DD日dddd')})
                        </Radio>
                      </Radio.Group>
                    )}
                    {typeContent === 'dateTime' && (
                      <Radio.Group
                        itemDirection="ver"
                        onChange={(value) => setTypeFormat(value)}
                        value={typeFormat}
                      >
                        <Radio value="YYYY/MM/DD HH:mm:ss">
                          格式一(ex:{moment().format('YYYY/MM/DD HH:mm:ss')})
                        </Radio>
                        <Radio value="YYYY-MM-DD HH:mm:ss">
                          格式二(ex:{moment().format('YYYY-MM-DD HH:mm:ss')})
                        </Radio>
                        <Radio value="YYYY年MM月DD日dddd a hh:mm:ss">
                          格式三(ex:
                          {moment().format('YYYY年MM月DD日dddd a hh:mm:ss')})
                        </Radio>
                      </Radio.Group>
                    )}
                    {typeContent === 'time' && (
                      <Radio.Group
                        onChange={(value) => setTypeFormat(value)}
                        value={typeFormat}
                      >
                        <Radio value="HH:mm">
                          格式一(ex:{moment().format('HH:mm')})
                        </Radio>
                        <Radio value="a hh:mm">
                          格式二(ex:{moment().format('a hh:mm')})
                        </Radio>
                      </Radio.Group>
                    )}
                    {typeContent === 'weather' && (
                      <Select
                        style={{ width: '100%', textAlign: 'center' }}
                        onChange={(value) => setCity(value)}
                        value={city}
                      >
                        {cityList.map((item) => (
                          <Option value={item}>{item}</Option>
                        ))}
                      </Select>
                    )}
                    {/* {typeContent === 'announcement' && (
                    <Select
                      style={{ width: '100%', textAlign: 'center' }}
                      onChange={(value) => setTypeFormat(value)}
                      value={typeFormat}
                    >
                      <Option value="全部">全部</Option>
                      {cateGoryMenuData.map((item) => (
                        <Option value={item}>{item}</Option>
                      ))}
                    </Select>
                  )} */}
                    {/* {typeContent === 'image' && (
                <Button>
                  <DownloadOutlined style={} />
                  從媒體庫匯入
                </Button>
              )} */}
                  </Item>
                )}
                {(typeContent === '空氣品質' ||
                  typeContent === '溫度' ||
                  typeContent === '濕度' ||
                  typeContent === '照度' ||
                  typeContent === '自定義') && (
                  <Item label="顯示欄位">
                    <Button onClick={() => setTypeValueDialog(true)}>
                      編輯項目內容
                    </Button>
                    <div style={{ marginTop: 10 }}>
                      {typeValueData.map((item, index) => (
                        <div key={index} style={{ marginBottom: 5 }}>
                          {index + 1}. {item.originName}({item.unitName})
                        </div>
                      ))}
                    </div>
                  </Item>
                )}

                {typeContent !== 'youtube' &&
                  typeContent !== 'mp4' &&
                  typeContent !== 'iframe' && (
                    <>
                      <Item label="文字樣式">
                        <NumberPicker
                          style={{ width: '70%', marginRight: 10 }}
                          defaultValue={textSize}
                          type="inline"
                          onChange={(value) => setTextSize(value)}
                        />
                        {tagsData.map((tag) => (
                          <CheckableTag
                            key={tag}
                            checked={textTags.indexOf(tag) > -1}
                            onChange={(checked) => handleChange(tag, checked)}
                          >
                            {tag}
                          </CheckableTag>
                        ))}
                      </Item>
                      <Item label="文字顏色">
                        <div
                          className={styles.textColorContent}
                          style={{
                            backgroundColor: textColor,
                            border: '1px dashed #D8D8D8',
                          }}
                          onClick={() => setShowAddColor(true)}
                        />
                        <Input
                          placeholder="例如：歡迎光臨..."
                          style={{ width: '90%' }}
                          value={textColor}
                          onClick={() => setShowAddColor(true)}
                          onChange={(e) => setTextColor(e.target.value)}
                        />
                        {showAddColor ? (
                          <>
                            <div
                              className={styles.cover}
                              onClick={() => setShowAddColor(false)}
                            />
                            <SketchPicker
                              className={styles.colorPicker}
                              color={textColor}
                              onChangeComplete={(color) => {
                                setTextColor(color.hex);
                              }}
                            />
                          </>
                        ) : null}
                      </Item>
                    </>
                  )}
              </>
            )}
            {typeContent !== 'youtube' &&
              typeContent !== 'mp4' &&
              typeContent !== 'iframe' && (
                <Item label="水平位置">
                  <Select
                    style={{ width: '100%' }}
                    value={textLevel}
                    onChange={(value) => setTextLevel(value)}
                  >
                    <Option value="left">靠左</Option>
                    <Option value="center">置中</Option>
                    <Option value="right">靠右</Option>
                  </Select>
                </Item>
              )}
            {typeContent !== 'announcement' &&
              typeContent !== 'image' &&
              typeContent !== 'youtube' &&
              typeContent !== 'mp4' && (
                <Item label="垂直位置">
                  <Select
                    style={{ width: '100%' }}
                    value={textVertical}
                    onChange={(value) => setTextVertical(value)}
                  >
                    <Option value="start">靠上</Option>
                    <Option value="center">置中</Option>
                    <Option value="end">靠下</Option>
                  </Select>
                </Item>
              )}
            {typeContent !== 'youtube' && typeContent !== 'mp4' && (
              <Item label="時間">
                <Input
                  placeholder="Basic usage"
                  addonAfter={selectAfter}
                  value={secValue}
                  onChange={(e) => {
                    if (!isNaN(e.target.value)) {
                      if (
                        parseInt(e.target.value, 10) <= 0 ||
                        e.target.value === ''
                      ) {
                        setSecValue('');
                      } else {
                        setSecValue(parseInt(e.target.value, 10));
                      }
                    }
                  }}
                />
              </Item>
            )}
            {typeContent === 'youtube' && (
              <>
                <Item label="標題">
                  <Input
                    value={youtubeTitle}
                    onChange={(e) => {
                      setYoutubeTitle(e.target.value);
                    }}
                  />
                </Item>
                <Item label="開始播放">
                  <InputNumber
                    // addonAfter={selectAfter}
                    min={1}
                    max={maxEndTime}
                    suffix="秒"
                    value={secValue}
                    onChange={(value) => {
                      setSecValue(value);
                    }}
                  />
                </Item>
                <Item label={`結束播放(最大${maxEndTime}秒)`}>
                  <InputNumber
                    suffix="秒"
                    min={1}
                    max={maxEndTime}
                    value={endTime}
                    onChange={(value) => {
                      setEndTime(value);
                    }}
                  />
                </Item>
                <Item label="聲音">
                  <Switch
                    checkedChildren="開啟"
                    unCheckedChildren="關閉"
                    checked={sound}
                    // style={{ marginRight: 10 }}
                    onChange={(checked) => setSound(checked)}
                  />
                </Item>
              </>
            )}
            {typeContent === 'mp4' && (
              <>
                <Item label="標題">
                  <Input
                    value={youtubeTitle}
                    onChange={(e) => {
                      setYoutubeTitle(e.target.value);
                    }}
                  />
                </Item>
                <Item label="影片" required>
                  {/* <Input /> */}
                  <Space wrap>
                    <Button
                      onClick={() => {
                        uploadRef.current.click();
                        setSoundLoading(true);
                      }}
                    >
                      {backgroundMusic ? '更換附件' : '上傳附件'}
                    </Button>
                    {uploadData && (
                      <>
                        <Typography.Text type="secondary">
                          {uploadData.name}
                        </Typography.Text>
                        <Button
                          text
                          onClick={() => {
                            setUploadData(null);
                            setUploadPath('');
                          }}
                          style={{ opacity: 0.45, marginLeft: 10 }}
                        >
                          <DeleteOutlined className={styles.boxIcon} />
                        </Button>
                      </>
                    )}
                    {!uploadData && backgroundMusic && (
                      <>
                        <Typography.Text type="secondary">
                          {backgroundMusic.name}
                        </Typography.Text>
                        <Button
                          text
                          onClick={() => {
                            setBackgroundMusic(null);
                          }}
                          style={{ opacity: 0.45, marginLeft: 10 }}
                        >
                          <DeleteOutlined className={styles.boxIcon} />
                        </Button>
                      </>
                    )}
                  </Space>
                  <input
                    ref={uploadRef}
                    type="file"
                    id="upload"
                    accept=".mp4"
                    value={uploadPath || ''}
                    style={{ display: 'none' }}
                    onChange={async (e) => {
                      const file = e.target.files[0];
                      setUploadData(file);
                      setUploadPath(e.target.value);
                      const body = new FormData();
                      body.append('files', file);
                      const res = await fetch('/newUploads?type=broadcast', {
                        method: 'POST',
                        body,
                        headers: {
                          authorization: window.localStorage['feathers-jwt'],
                        },
                      });

                      const { showPath, videoDuration, _id } = (
                        await res.json()
                      )[0];
                      console.log(showPath);
                      setNewMp4({
                        videoDuration: Math.round(videoDuration / 1000),
                        path: showPath,
                        name: file.name,
                        id: _id,
                      });
                      setSoundLoading(false);
                      setYoutubeTitle(file.name.split('.')[0]);
                    }}
                  />
                </Item>

                <Item
                  label={`播放時間${
                    NewMp4.videoDuration === 0
                      ? '(未上傳)'
                      : `(最大${NewMp4.videoDuration}秒)`
                  }`}
                >
                  <InputNumber
                    suffix="秒"
                    min={1}
                    max={NewMp4.videoDuration}
                    value={secValue}
                    onChange={(value) => {
                      setSecValue(value);
                    }}
                  />
                </Item>
                <Item label="聲音">
                  <Switch
                    checkedChildren="開啟"
                    unCheckedChildren="關閉"
                    checked={sound}
                    // style={{ marginRight: 10 }}
                    onChange={(checked) => setSound(checked)}
                  />
                </Item>
              </>
            )}

            {typeContent === 'image' && (
              <div
                className={styles.showAddText}
                style={{
                  display: 'flex',
                  backgroundColor:
                    addTemplateContent[TemplateDialogCount].color,
                  fontSize: textSize,
                  color: textColor,
                  backgroundImage: `url(${typeFormat})`,
                  height: '10vw',
                  backgroundSize:
                    (textSize === 'fullVersion' && 'cover') ||
                    (textSize === 'originalSize' && 'Contain') ||
                    (textSize === 'repeat' && 'Contain'),
                  backgroundRepeat:
                    textSize === 'repeat' ? 'repeat' : 'no-repeat',
                  backgroundPosition: textLevel,
                }}
              />
            )}
            {typeContent !== 'image' &&
              typeContent !== 'youtube' &&
              typeContent !== 'mp4' && (
                <div
                  className={styles.showAddText}
                  style={{
                    display: 'flex',
                    backgroundColor:
                      addTemplateContent[TemplateDialogCount].color,
                    fontSize: textSize,
                    color: textColor,
                    fontWeight:
                      textTags.indexOf('粗體') >= 0 ? '900' : 'normal',
                    fontStyle:
                      textTags.indexOf('斜體') >= 0 ? 'italic' : 'normal',
                    justifyContent: textLevel,
                    paddingTop:
                      (textVertical === 'start' && 0) ||
                      (textVertical === 'center' && 40) ||
                      (textVertical === 'end' && 80),
                    paddingBottom:
                      (textVertical === 'start' && 80) ||
                      (textVertical === 'center' && 40) ||
                      (textVertical === 'end' && 0),
                  }}
                >
                  文字內容
                </div>
              )}
          </Form>
        </Spin>
      </Dialog>

      {/* 媒體庫匯入(多選) */}
      <Dialog
        hasMask
        className={styles.dialogMedia}
        visible={TemplateImageDialog}
        onOk={() => {
          setTemplateImageDialog(false);
          setTypeContent('image');
          onChangeTemplateContent('image');
        }}
        onCancel={() => {
          setTemplateImageDialog(false);
          onChangeInitialValue();
        }}
        onClose={() => {
          setTemplateImageDialog(false);
          onChangeInitialValue();
        }}
      >
        <h3>媒體庫匯入</h3>
        <div>
          <div className={styles.MediaSearch}>
            類別：
            <Select
              onChange={(value) => {
                setMediaType(value);
                onChangeMediaType(value);
              }}
              value={mediaType}
            >
              <Option value="all">全部</Option>
              <Option value="announceBroadcast">公告</Option>
              <Option value="broadcast">公播</Option>
            </Select>
          </div>
          <div className={styles.MediaBtn}>
            <span style={{ color: '#FF0000', marginRight: 10 }}>
              *可上傳jpeg/png
            </span>
            <Upload
              accept="image/jpeg,image/png"
              // listType="picture-card"
              multiple={true}
              showUploadList={false}
              beforeUpload={(file) => beforeUpload(file)}
            >
              <Button style={{ marginRight: 10 }}>
                <UploadOutlined />
                新增圖片
              </Button>
            </Upload>
            <Button
              className={styles.boxRowBtn}
              onClick={() => {
                Swal.fire({
                  title: '您確定要刪除圖片嗎?',
                  text: '刪除將無法復原',
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#BEBEBE',
                  confirmButtonText: '確定',
                  cancelButtonText: '取消',
                }).then((result) => {
                  if (result.isConfirmed) {
                    onDeleteBox();
                  }
                });
              }}
            >
              <DeleteOutlined className={styles.boxIcon} />
              刪除圖片
            </Button>
          </div>
        </div>

        <div className={styles.MediaContent}>
          <Spin spinning={upLoading}>
            <Checkbox.Group
              style={{ width: '100%' }}
              onChange={onChange}
              className={styles.MediaImage}
              // value={checkValue}
            >
              <Row>
                {mediaImage
                  ? mediaImage.map((i, index) => (
                      <Col span={4} key={index}>
                        <Checkbox value={i.showPath}>
                          <div className={styles.MediaImage}>
                            <img
                              src={i.showPath}
                              width="100%"
                              height="100%"
                              alt="圖片"
                            />
                          </div>

                          <div className={styles.MediaImageName}>
                            {i.orignalName.includes('announceBroadcast') > 0
                              ? '公告'
                              : '公播'}
                            <br />
                            {mediaIndex === index ? (
                              <Input
                                value={mediaUpdate[0]}
                                suffix={`.${mediaUpdate[1]}`}
                                onChange={(e) => {
                                  if (e.target.value === '') {
                                    Message.error('請輸入檔案名稱');
                                  } else {
                                    setMediaUpdate([
                                      e.target.value,
                                      mediaUpdate[1],
                                    ]);
                                  }
                                }}
                              />
                            ) : (
                              i.oldName
                            )}

                            <br />
                            {mediaIndex === index ? (
                              <div>
                                <CheckOutlined
                                  style={{ color: '#006030' }}
                                  onClick={() => {
                                    uploads.patch(i._id, {
                                      ...i,
                                      oldName: mediaUpdate.join('.'),
                                    });
                                    setMediaIndex('');
                                    setIsUpdate((pre) => !pre);
                                  }}
                                />
                                <CloseOutlined
                                  style={{ color: '#CE0000', marginLeft: 10 }}
                                  onClick={() => {
                                    setMediaIndex('');
                                    setIsUpdate((pre) => !pre);
                                  }}
                                />
                              </div>
                            ) : (
                              <EditOutlined
                                onClick={() => {
                                  setMediaIndex(index);
                                  setMediaUpdate(i.oldName.split('.'));
                                }}
                              />
                            )}
                          </div>
                        </Checkbox>
                      </Col>
                    ))
                  : null}
              </Row>
            </Checkbox.Group>
          </Spin>
        </div>
      </Dialog>

      {/* 媒體庫更換圖片 */}
      <Dialog
        hasMask
        className={styles.dialogMedia}
        visible={TemplateImageChangeDialog}
        onOk={() => {
          setTemplateImageChangeDialog(false);
        }}
        onCancel={() => {
          setTemplateImageChangeDialog(false);
        }}
        onClose={() => {
          setTemplateImageChangeDialog(false);
        }}
      >
        <h3>媒體庫匯入</h3>
        <div>
          <div className={styles.MediaSearch}>
            類別：
            <Select
              onChange={(value) => {
                setMediaType(value);
                onChangeMediaType(value);
              }}
              value={mediaType}
            >
              <Option value="all">全部</Option>
              <Option value="announcement">公告</Option>
              <Option value="broadcast">公播</Option>
            </Select>
          </div>
          <div className={styles.MediaBtn}>
            <span style={{ color: '#FF0000', marginRight: 10 }}>
              *可上傳jpeg/png
            </span>
            <Upload
              accept="image/jpeg,image/png"
              multiple={true}
              showUploadList={false}
              beforeUpload={(file) => beforeUpload(file)}
            >
              <Button>
                <UploadOutlined />
                新增圖片
              </Button>
            </Upload>
            <Button
              className={styles.boxRowBtn}
              onClick={() => {
                Swal.fire({
                  title: '您確定要刪除圖片嗎?',
                  text: '刪除將無法復原',
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#BEBEBE',
                  confirmButtonText: '確定',
                  cancelButtonText: '取消',
                }).then((result) => {
                  if (result.isConfirmed) {
                    onDeleteBox();
                  }
                });
              }}
            >
              <DeleteOutlined className={styles.boxIcon} />
              刪除圖片
            </Button>
          </div>
        </div>

        <div className={styles.MediaContent}>
          <Spin spinning={upLoading}>
            <Radio.Group
              style={{ width: '100%' }}
              onChange={(value) => setTypeFormat(value)}
              // className={styles.MediaImage}
              value={typeFormat}
            >
              <Row>
                {mediaImage
                  ? mediaImage.map((i, index) => (
                      <Col
                        span={4}
                        key={index}
                        style={{ paddingRight: 8, paddingLeft: 8 }}
                      >
                        <Radio value={i.showPath}>
                          <div className={styles.MediaImage}>
                            <img
                              src={i.compressImagePath}
                              width="100%"
                              height="100%"
                              alt="圖片"
                            />
                          </div>

                          <div
                            className={styles.MediaImageName}
                            style={{ paddingTop: 10 }}
                          >
                            {i.orignalName.includes('announceBroadcast') > 0
                              ? '公告'
                              : '公播'}
                            <br />

                            {i.oldName}
                          </div>
                        </Radio>
                      </Col>
                    ))
                  : null}
              </Row>
            </Radio.Group>
          </Spin>
        </div>
      </Dialog>

      {/* 即時空氣品質欄位項目編輯 */}
      <Dialog
        hasMask
        className={styles.dialogType}
        visible={typeValueDialog}
        onOk={() => {
          setTypeValueDialog(false);
          console.log(typeValueData);
          setTypeFormat(typeValueData);
          // form.submit();
        }}
        onCancel={() => {
          setTypeValueDialog(false);
        }}
        onClose={() => {
          setTypeValueDialog(false);
        }}
      >
        <h3>項目編輯</h3>
        <Form inline colon>
          <Item label="裝置名稱" required>
            <Select
              value={typeValue?.originName}
              style={{ width: '150px' }}
              onChange={(value) => {
                const newUnit = unit.filter((i) => value.includes(i.name));
                const newData = {
                  originName: value,
                  newName: value,
                  ...newUnit[0],
                };
                setTypeValue(newData);
              }}
            >
              {typeColumns.map((i) => (
                <Option value={i}>{i}</Option>
              ))}
            </Select>
          </Item>
          <Item label="顯示名稱" required>
            <Input
              value={typeValue?.newName}
              onChange={(e) => {
                const newData = { ...typeValue };
                newData.newName = e.target.value;
                setTypeValue(newData);
                const res = typeValueData.filter(
                  (item) => item.newName === e.target.value
                );
                if (res.length > 0) {
                  Message.error('顯示名稱不能重複');
                  setErrorText('顯示名稱不能重複');
                } else {
                  setErrorText('');
                }
              }}
            />
            {errorText && <p style={{ color: '#FF0000' }}>{errorText}</p>}
          </Item>
          <Item>
            <Button
              type="primary"
              onClick={() => {
                if (typeValue?.originName && typeValue?.newName) {
                  const res = typeValueData.filter(
                    (item) => item.newName === typeValue.newName
                  );
                  if (res.length > 0) {
                    Message.error('顯示名稱不能重複');
                    setErrorText('顯示名稱不能重複');
                  } else {
                    const NewTypeValueData = [...typeValueData];
                    NewTypeValueData.push(typeValue);
                    setTypeValueData(NewTypeValueData);
                    setTypeValue(null);
                    setErrorText('');
                  }
                } else {
                  Message.error('請輸入裝置名稱與顯示名稱');
                }
              }}
            >
              新增
            </Button>
          </Item>
        </Form>
        <p>
          <font style={{ color: 'red' }}>*</font>可拖曳表格欄位變換順序
        </p>
        <ReactDragListView
          onDragEnd={(fromIndex, toIndex) =>
            onTypeDragCategoryEnd(fromIndex, toIndex)
          }
        >
          <Table dataSource={typeValueData}>
            <Table.Column title="裝置名稱" dataIndex="originName" />
            <Table.Column
              title="顯示名稱"
              dataIndex="newName"
              cell={(value, index) => {
                if (editable === index) {
                  return (
                    <>
                      <Input
                        value={value}
                        onChange={(e) => {
                          const newData = [...typeValueData];
                          const res = newData.filter(
                            (item) => item.newName === e.target.value
                          );
                          if (res.length > 0) {
                            Message.error('顯示名稱不能重複');
                            setErrorTable('顯示名稱不能重複');
                            newData[index].newName = e.target.value;
                            setTypeValueData(newData);
                          } else {
                            setErrorTable('');
                            newData[index].newName = e.target.value;
                            setTypeValueData(newData);
                          }
                        }}
                      />
                      {errorTable && (
                        <p style={{ color: '#FF0000' }}>{errorTable}</p>
                      )}
                    </>
                  );
                } else {
                  return <span>{value}</span>;
                }
              }}
            />
            <Table.Column
              title="倍率"
              dataIndex="unitValue"
              cell={(value, index) => {
                if (editable === index) {
                  return (
                    <Input
                      value={value}
                      onChange={(e) => {
                        const newData = [...typeValueData];
                        newData[index].unitValue = e.target.value;
                        setTypeValueData(newData);
                      }}
                    />
                  );
                } else {
                  return <span>{value}</span>;
                }
              }}
            />
            <Table.Column
              title="單位"
              dataIndex="unitName"
              cell={(value, index) => {
                if (editable === index) {
                  return (
                    <Input
                      value={value}
                      onChange={(e) => {
                        const newData = [...typeValueData];
                        newData[index].unitName = e.target.value;
                        setTypeValueData(newData);
                      }}
                    />
                  );
                } else {
                  return <span>{value}</span>;
                }
              }}
            />
            <Table.Column
              title="操作"
              width={200}
              cell={(value, index) => {
                return (
                  <>
                    {editable === '' && (
                      <Button
                        type="normal"
                        className={styles.buttonAdd}
                        onClick={() => setEditable(index)}
                      >
                        編輯
                      </Button>
                    )}
                    {editable === index && errorTable === '' && (
                      <>
                        <Button
                          type="normal"
                          className={styles.buttonAdd}
                          onClick={() => {
                            setEditable('');
                          }}
                        >
                          確認
                        </Button>
                      </>
                    )}
                    <Button
                      type="primary"
                      className={styles.buttonAdd}
                      warning
                      onClick={() => {
                        const newTypeValueData = [...typeValueData];
                        newTypeValueData.splice(index, 1);
                        setTypeValueData(newTypeValueData);
                      }}
                    >
                      刪除
                    </Button>
                  </>
                );
              }}
            />
          </Table>
        </ReactDragListView>
      </Dialog>
    </div>
  );
};

export default BroadcastTemplateSetting;
